<template>
  <v-app>
    <div class="ecommerce" :class="{ 'seagull-theme': isSeagull }">
      <template
        v-if="currentProduct && showProductModal && currentProduct.status"
      >
        <template v-if="pageProfile.type == 'forex'">
          <modal-forex-product
            style="min-height: 100vh"
            v-model="currentProduct"
            :key="currentProduct.id"
            :products="allproducts"
            :pageProfile="pageProfile"
            @addToCart="addToCart"
            @close="closeProduct"
            :loading-cart="loadingCart"
          ></modal-forex-product>
        </template>
        <template v-else-if="pageProfile.type == 'runkan'">
          <modal-runkan-product
            style="min-height: 100vh"
            v-model="currentProduct"
            :key="currentProduct.id"
            :products="allproducts"
            :pageProfile="pageProfile"
            @addToCart="addToCart"
            @close="closeProduct"
            :loading-cart="loadingCart"
          ></modal-runkan-product>
        </template>
        <template v-else-if="pageProfile.theme === 'seagull'">
          <ModalSeagullProduct
            :categories="filterCategory"
            style="min-height: 100vh"
            v-model="currentProduct"
            :key="currentProduct.id"
            :products="allproducts"
            :pageProfile="pageProfile"
            @addToCart="addToCart"
            @close="closeProduct"
            @openCheckout="openCheckout"
            :loading-cart="loadingCart"
          />
        </template>
        <template v-else>
          <template v-if="pageProfile.pageid != '485851741439218'">
            <modal-product
              :categories="filterCategory"
              style="min-height: 100vh"
              v-model="currentProduct"
              :key="currentProduct.id"
              :products="allproducts"
              :pageProfile="pageProfile"
              @addToCart="addToCart"
              @close="closeProduct"
              @openCheckout="openCheckout"
              :loading-cart="loadingCart"
            ></modal-product>
          </template>
          <template v-else>
            <modal-product2
              :categories="filterCategory"
              style="min-height: 100vh"
              v-model="currentProduct"
              :key="currentProduct.id"
              :products="allproducts"
              :pageProfile="pageProfile"
              @addToCart="addToCart"
              @close="closeProduct"
              @openCheckout="openCheckout"
              :loading-cart="loadingCart"
            ></modal-product2>
          </template>
        </template>
      </template>

      <ManageCart
        v-else-if="
          showModal ||
          this.$store.state.newCentralPage.includes(this.pageProfile.pageid)
        "
        :viewTransferPage="viewTransferPage"
        :loadingCart="loadingCart"
        :loadingCheckout="loadingCheckout"
        :isCDS="isCDS"
        :isFoodguru="isFoodguru"
        :products="products"
        :filterCart="filterCart"
        :filterCategory="filterCategory"
        :timestamp="timestamp"
        :onlyOneQuantity="onlyOneQuantity"
        @checkout="checkout"
        @onUpdateStock="onUpdateStock"
        @onClose="close"
        @onDeleteItemInCart="deleteItemInCart"
        @onSelectProduct="onSelectProduct"
        @onChangeAddon="onChangeAddon"
      />

      <div v-if="!showProductModal && !showModal">
        <div class="container" v-if="productLoading">
          <sync-loader
            :key="theme.color"
            :color="theme.color"
            :size="'10px'"
            style="
              position: absolute;
              top: 50%;
              margin-top: -10px;
              left: 50%;
              margin-left: -21px;
            "
          ></sync-loader>
        </div>
        <template v-else>
          <div v-show="!isCDS && pageProfile.type != 'chillpainai'">
            <merchant-detail
              v-model="pageProfile"
              id="merchant"
              :showSearch="showSearch"
            >
              <template>
                <template slot="category">
                  <v-tabs
                    show-arrows
                    v-model="selectedCategory"
                    :slider-color="theme.color"
                    @change="onChangeCategory"
                    active-class="v-tabs__item--active primary lighten-1 white--text"
                  >
                    <template v-if="['foodguru'].includes(pageProfile.type)">
                      <v-tab
                        v-if="hasUsedToBuy"
                        :key="'used_to_buy_product'"
                        @touchstart="selectedCategory = 'usedtobuy'"
                        :href="'#usedtobuy'"
                      >
                        สินค้าที่เคยซื้อ
                      </v-tab>
                      <v-tab
                        :key="'category_all'"
                        @touchstart="selectedCategory = 'all'"
                        :href="'#all'"
                        >{{ $t('All') }}</v-tab
                      >
                    </template>
                    <template
                      v-if="
                        !['nvbb', 'alice', 'foodguru'].includes(
                          pageProfile.type
                        )
                      "
                    >
                      <v-tab
                        :key="'category_all'"
                        @touchstart="selectedCategory = 'all'"
                        :href="'#all'"
                        >{{ $t('All') }}</v-tab
                      >
                      <v-tab
                        v-if="hasSaleCategory"
                        :key="'category_sales'"
                        @touchstart="selectedCategory = 'sales'"
                        :href="'#sales'"
                      >
                        {{ $t('Sale') }}
                      </v-tab>
                    </template>

                    <template v-for="(category, cindex) in filterCategory">
                      <template v-if="category.productCount > 0">
                        <v-tab
                          show-arrows
                          :key="'category_' + cindex"
                          :href="'#' + category.id"
                          ripple
                          >{{
                            category.display_name
                              ? category.display_name
                              : category.name
                          }}</v-tab
                        >
                      </template>
                    </template>
                    <template v-if="['alice'].includes(pageProfile.type)">
                      <v-tab
                        :key="'category_all'"
                        @touchstart="selectedCategory = 'all'"
                        :href="'#all'"
                        >{{ $t('All') }}</v-tab
                      >
                      <v-tab
                        v-if="hasSaleCategory"
                        @touchstart="selectedCategory = 'sales'"
                        :key="'category_sales'"
                        :href="'#sales'"
                      >
                        {{ $t('Sale') }}
                      </v-tab>
                    </template>
                  </v-tabs>
                </template>
                <template slot="search">
                  <v-text-field
                    ref="search"
                    :color="theme.color"
                    v-if="showSearch"
                    :placeholder="
                      selectedCategory == 'all'
                        ? $t('Search all')
                        : $t('Search in {category}', {
                            category: currentCategory
                              ? currentCategory.name.replace(/\<|\>/g, '')
                              : ''
                          })
                    "
                    v-model="search"
                  ></v-text-field>
                  <v-btn icon @click="openSearch">
                    <v-icon v-if="!showSearch">mdi-magnify</v-icon>
                    <v-icon v-else>mdi-close</v-icon>
                  </v-btn>
                </template>
              </template>
            </merchant-detail>

            <v-content class="mb-5">
              <div v-if="$route.query.shoptoken">
                <v-alert :value="true" type="warning">
                  {{ $t('create_order_by_admin') }}
                </v-alert>
              </div>
              <v-container grid-list-md>
                <v-alert
                  :value="true"
                  v-if="
                    pageProfile && $store.state.cds.includes(pageProfile.pageid)
                  "
                  color="info"
                  icon="info"
                  outline
                  >กรุณากดปุ่ม "สรุปยอดสินค้า/Checkout" ด้านล่าง
                  เพื่อยืนยันการสั่งซื้อ</v-alert
                >
                <!-- {{ userAgent }} -->

                <v-layout wrap row v-else>
                  <template v-if="filterProducts.length > 0">
                    <template v-for="(product, pindex) in filterProducts">
                      <product
                        :key="'product_' + filterProducts[pindex].id"
                        v-model="filterProducts[pindex]"
                        @addToCart="addToCart"
                        @openCheckout="openCheckout"
                        @selectProduct="onSelectProduct(filterProducts[pindex])"
                      ></product>
                    </template>
                    <v-flex xs12>
                      <div class="text-xs-center mt-4 mb-4">
                        <v-pagination
                          :color="theme.color"
                          v-model="pageNumber"
                          :length="pageCount"
                        ></v-pagination>
                      </div>
                    </v-flex>
                  </template>
                  <template v-else>
                    <div class="text-xs-center" style="margin: 25px auto">
                      <img
                        src="../assets/img/ecommerce/empty_shopping_cart@4x.png"
                        alt
                        style="width: 100px; margin-bottom: 10px"
                      />
                      <h4>{{ $t('No product') }}</h4>
                    </div>
                  </template>
                </v-layout>
                <div
                  class="text-xs-center"
                  style="padding-top: 15px; padding-bottom: 15px"
                >
                  <a
                    href="javascript:void(0);"
                    @click="openTerm()"
                    style="color: rgb(169, 169, 169)"
                    >{{
                      ['seagull'].includes(pageProfile.theme)
                        ? 'นโยบายความเป็นส่วนตัวและการรับประกัน'
                        : $t('Terms & Condition & Refund Prolicy')
                    }}.</a
                  >
                </div>
              </v-container>
            </v-content>
            <div
              id="filter"
              class="filter"
              style="
                background: white;
                overflow: auto;
                border-top: 1px solid #eee;
              "
              v-if="false"
            >
              <div id="container" class="container">
                <div style="display: flex">
                  <div
                    id="categories"
                    class="categories"
                    v-if="!showSearch"
                    style="flex: 1 1 40%"
                    :class="{ 'hidden-xs': showSearch }"
                    :style="{ width: categoriesWidth }"
                  >
                    <ul class="list">
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="btn"
                          @click="selectedCategory = 'all'"
                          :class="{
                            'btn-primary': selectedCategory == 'all',
                            'btn-default': selectedCategory != 'all'
                          }"
                          >{{ $t('All') }}</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="btn"
                          @click="selectedCategory = 'sales'"
                          :class="{
                            'btn-primary': selectedCategory == 'sales',
                            'btn-default': selectedCategory != 'sales'
                          }"
                          >{{ $t('Sale') }}</a
                        >
                      </li>
                      <template v-for="(category, cindex) in filterCategory">
                        <li
                          :key="'category_' + cindex"
                          v-if="category.productCount > 0"
                        >
                          <a
                            href="javascript:void(0);"
                            class="btn"
                            @click="selectedCategory = category.id"
                            :class="{
                              'btn-primary': selectedCategory == category.id,
                              'btn-default': selectedCategory != category.id
                            }"
                            >{{ category.name }}</a
                          >
                        </li>
                      </template>
                    </ul>
                  </div>

                  <div
                    id="search-btn"
                    style="
                      position: relative;
                      display: inline-block;
                      padding: 15px;
                      font-size: 18px;
                      margin-top: 5px;
                    "
                  >
                    <a href="javascript:void(0);" style @click="openSearch()">
                      <span
                        class="glyphicon"
                        :class="{
                          'glyphicon-search': !showSearch,
                          'glyphicon-remove': showSearch
                        }"
                      ></span>
                    </a>
                  </div>

                  <div
                    class="search-container"
                    v-if="showSearch"
                    style="width: 100%"
                  >
                    <span class="clearable" style="width: 100%">
                      <input
                        type="text"
                        class="form-control"
                        ref="search"
                        v-model="search"
                        :placeholder="$t('Search')"
                      />
                      <i
                        class="clearable__clear"
                        :class="{ show: search != '' }"
                        @click="search = ''"
                        >&times;</i
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>

            <template
              v-if="!['forex', 'ros', 'runkan'].includes(pageProfile.type)"
            >
              <div
                v-if="memberGroup"
                style="position: fixed; bottom: 70px; right: 10px"
              >
                <small
                  >{{ $t('Order by') }} : {{ memberGroup.display_name }}</small
                >
              </div>
              <v-bottom-nav
                :value="true"
                :color="theme.color"
                dark
                style="height: 68px; z-index: 3"
                :style="{
                  'padding-bottom': $store.getters.getIosPadding ? '15px' : '0',
                  position: 'fixed'
                }"
                :class="{ 'seagull-btn-footer': isSeagull }"
              >
                <v-btn
                  style="max-width: 100%"
                  flat
                  value="nearby"
                  @click="openModal"
                >
                  <span
                    >{{ isSeagull ? $t('shopping_cart') : $t('Checkout') }}
                  </span>
                  <v-badge color="red">
                    <template v-slot:badge v-if="totalItem > 0">
                      <span>{{ totalItem }}</span>
                    </template>
                    <v-icon>{{
                      isSeagull ? 'mdi-cart-outline' : 'mdi-cart-plus'
                    }}</v-icon>
                  </v-badge>
                </v-btn>
              </v-bottom-nav>
              <div v-if="isSeagull" class="seagull-footer">
                <div>บริษัท ไทยสเตนเลสสตีล จำกัด</div>
                <div>&copy; 2023 Thai Stainless Steel Co., Ltd.</div>
              </div>
            </template>
          </div>
        </template>
      </div>

      <Loading v-if="loadingCheckout"></Loading>

      <v-dialog :value="showRedirectToSocial" max-width="400">
        <v-card>
          <v-card-title>
            <span class="headline" :style="{ color: theme.color }">
              {{ $route.query.testbot ? 'หมายเหตุ' : $t('Login to checkout') }}
            </span>
            <v-spacer></v-spacer>
            <v-btn flat fab small @click="showRedirectToSocial = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text :class="$route.query.testbot ? 'pt-0' : ''">
            <div class="text-xs-center">
              <div v-if="!$route.query.testbot">
                <v-btn
                  :href="redirecturl"
                  :color="'#2975eb'"
                  dark
                  class="mb-4"
                  large
                >
                  <img
                    src="../assets/img/social/icon-facebook.png"
                    alt="facebook button"
                    style="width: 16px; margin-right: 10px"
                  />
                  <span>{{ $t('Sign in with Facebook') }}</span>
                </v-btn>
              </div>
              <div v-else>
                ในส่วนนี้ใช้สำหรับในการทดสอบบอทเบื้องต้นเท่านั้น
                หากต้องการทดสอบการสั่งซื้ออย่างเต็มรูปแบบ
                สามารถทดสอบผ่านทางกล่องข้อความของเพจ
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <template v-if="['seagull'].includes(pageProfile.theme)">
        <SeagullTermAndCondition
          :pageid="pageProfile.pageid"
          v-if="showTerm"
          @close="closeTerm()"
        ></SeagullTermAndCondition>
      </template>
      <template v-else>
        <term-and-condition
          :pageid="pageProfile.pageid"
          v-if="showTerm"
          @close="closeTerm()"
        ></term-and-condition>
      </template>

      <v-dialog
        v-model="showFoodguruTerm"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <ModalFoodguruTerm
          :pageid="pageProfile.pageid"
          :userid="userid"
          @close="closeFoodguruTerm()"
        ></ModalFoodguruTerm>
      </v-dialog>

      <v-dialog v-model="showShop" max-width="600" persistent>
        <v-card>
          <v-card-text>
            <div class="text-xs-center mb-2">
              เลือกร้านจากจุดบนแผนที่เพื่อหาร้านที่ใกล้ที่สุด
            </div>
            <gmap-near-shop
              v-if="showmap"
              :showRadius="true"
              :placesinfo="placesinfolabel"
              v-validate="{ required: true }"
              name="gmapaddress"
              v-model="gmapvalue"
              v-on:input="gmapLocation"
              :lastordercoords="lastordercoords"
              :error="errors.has('gmapaddress')"
              :shoplocation="branchlocation"
              :radius="1000"
              :radiusColor="theme.color"
            ></gmap-near-shop>
            <div class="mb-2"></div>

            <div class="text-xs-center">ร้าน {{ shop }} ใกล้คุณที่สุด</div>
            <div class="text-xs-center">
              <v-btn
                @click="selectShop"
                :color="theme.color"
                depressed
                dark
                :loading="loadingmap"
                >เลือก</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Shipping Fee Foodguru -->
      <v-dialog
        v-if="['foodguru'].includes(pageProfile.type)"
        v-model="ModalShippingFeeFoodguru"
        max-width="500"
        persistent
      >
        <v-card>
          <div>
            <div style="text-align: right">
              <v-btn icon @click="closeShippingFeeFoodguru()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <div
              style="
                font-size: 14px;
                padding-left: 24px;
                padding-right: 24px;
                padding-bottom: 24px;
              "
            >
              <p style="font-weight: 700; font-size: 16px">เงื่อนไขการจัดส่ง</p>
              <p>
                <span style="font-weight: 700; font-size: 16px">
                  ออเดอร์ที่มีของสด</span
                >
                <br />ส่งผ่านขนส่ง SCG Express / รถบริษัท
              </p>
              <p>
                กทม. <br />ค่าส่ง 150 บาท <br />ซื้อ 1,500 บาท ขึ้นไป
                <span style="color: #f41818">ส่งฟรี</span>
              </p>
              <p>
                ตจว. <br />ค่าส่ง 270 บาท <br />ซื้อ 4,000 บาท ขึ้นไป
                <span style="color: #f41818">ส่งฟรี</span>
              </p>
              <p>
                ชำระเงินก่อน 13.00 น. ได้รับสินค้าวันถัดไป <br />ชำระเงินหลัง
                13.00 น. ได้รับสินค้า 2 วันถัดไป
              </p>
              <p style="font-size: 12px">
                หมายเหตุ : สถานที่จัดส่งใน กทม หากต้องการรับสินค้าภายในวัน
                ส่งโดย Skootar คิดค่าส่งตามระยะทางจริง
              </p>
              <p>
                <span style="font-weight: 700; font-size: 16px">ของแห้ง</span>
                <br />50 บาท <br />ส่งผ่านขนส่ง Flash Express / ไปรษณีย์
              </p>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <template v-if="['nestle'].includes(pageProfile.type)">
        <BundleSelect @addToCart="addToCart" />
      </template>
      <template
        v-if="viewTransferPage && $route.query && $route.query.shoptoken"
      >
        <transfer> </transfer>
      </template>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

import config from '@/config'
import axios from 'axios'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

import Product from '@/components/ecommerce/Product.vue'

import ModalCheckout from '@/components/ecommerce/ModalCheckout.vue'
import Loading from '@/components/Loading.vue'
import Modal from '@/components/Modal.vue'

import { bundleApi } from '@/api/bundles.js'
import { seagullApi } from '@/api/seagull.js'
import BundleSelect from '@/components/ecommerce/Bundles/BundleSelect'
import ManageCart from '@/components/ecommerce/Cart/ManageCart'
import ModalSeagullProduct from '@/components/ecommerce/Customize/Seagull/ModalProduct.vue'
import GmapNearShop from '@/components/ecommerce/GmapNearShop.vue'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'
import ModalFoodguruTerm from '@/components/ecommerce/ModalFoodguruTerm.vue'
import ModalForexProduct from '@/components/ecommerce/ModalForexProduct.vue'
import ModalProduct from '@/components/ecommerce/ModalProduct.vue'
import ModalProduct2 from '@/components/ecommerce/ModalProduct2.vue'
import ModalRunkanProduct from '@/components/ecommerce/ModalRunkanProduct.vue'
import SeagullTermAndCondition from '@/components/ecommerce/SeagullTermAndCondition.vue'
import TermAndCondition from '@/components/ecommerce/TermAndCondition.vue'
import VoucherCode from '@/components/ecommerce/VoucherCode.vue'
import Pagination from '@/components/Pagination'
import Transfer from '@/views/Transfer/main.vue'
import moment from 'moment'

export default {
  data: function () {
    return {
      onlyOneQuantity: false,
      viewTransferPage: false,
      userAgent: '',
      currentProduct: null,
      // pageid: null,
      userid: null,
      categories: [],
      products: {},
      productlist: [],

      shop: null,
      showShop: false,
      showFoodguruTerm: false,

      showmap: false,
      gmapvalue: '',

      shopOptions: [
        'Sukhumvit 49',
        'Surawong',
        'Panya Village',
        'Villa Aree',
        'Samyan Mitr Town (G Flr)',
        'Siam Paragon (G Flr)',
        'Central Ladplao (B Flr)',
        'Central Changwattana',
        'Central Eastville (G Flr)',
        'Central Rama 9 (B Flr)',
        'The Circle Rachapruk',
        'SB Rachapruk',
        'Dentral Hospital',
        'The Cystral Ekkamai-Ramindra',
        'Central Westgate',
        'The Mall Bangkapi',
        'PTT Aomnoi',
        'PTT Puttasakorn (Arrival)',
        'PTT Puttasakorn (Departure)'
      ],

      selectedCategory: 'all',
      tmpSelectedCategory: 'all',

      showModal: false,
      showProductModal: false,
      showRedirectToSocial: false,
      showAlert: false,
      showTerm: false,
      showBox: false,
      showDelete: false,
      showSearch: false,

      productLoading: true,
      loadingCheckout: false,
      profileLoading: false,

      redirecturl: null,

      pageid: null,
      config: {
        color: config.color
      },
      sessiontoken: null,
      loadingCart: true,
      memberGroup: null,
      deleteIndex: null,

      scrollY: null,

      search: '',
      categoriesWidth: '0px',
      pageNumber: 1,
      productCount: 0,
      size: 20,
      voucherCode: null,
      voucher: null,
      text: '',
      timestamp: moment().format('x'),
      hasSaleCategory: false,
      hasUsedToBuy: false,
      allproducts: [],
      placesinfo: '',
      ggmapdistance: null,
      lastordercoords: null,
      loadingmap: true,
      ableToShipping: false,
      kanomshippingprice: 0,
      hasVoucher: false,
      ModalShippingFeeFoodguru: false,
      isFoodguru: false
    }
  },
  computed: {
    placesinfolabel() {
      return (
        this.placesinfo +
        ` (${this.ggmapdistance ? this.ggmapdistance.distance : 0} Km)` +
        `<div style="margin-top: 5px;border-radius: 5px;padding: 5px; color: white; background: ${
          this.ableToBuy ? 'green' : 'red'
        }">${
          this.ableToBuy
            ? ` ค่าส่ง ${this.customShippingPrice} บาท`
            : ' ไม่สามารถจัดส่งได้'
        }</div>` +
        `<div class="mt-2">หรือรับที่ร้านฟรีค่าจัดส่ง</div>`
      )
    },
    ableToBuy() {
      return this.ableToShipping
    },
    customShippingPrice() {
      return this.kanomshippingprice
    },
    filterCategory() {
      const vm = this
      if (!vm.categories) {
        return []
      }
      if (vm.pageProfile && vm.pageProfile.type == 'kanom') {
        var categories = vm.categories
          .filter((el) => {
            return el.name.includes(vm.shop)
          })
          .map((el) => {
            var cat = { ...el }
            cat.name = cat.name.replace(vm.shop + '/', '')
            return cat
          })
        return categories
      } else {
        vm.categories = vm.categories.filter((el) => {
          if (vm.pageProfile && !vm.pageProfile.zortout_is_active) {
            return el.ref_code !== 'ZORTOUT' && !el.is_hidden
          }
          return !el.is_hidden
        })
        vm.categories.forEach((item, i) => {
          if (item.name === 'ZORTOUT-BUNDLE') {
            vm.categories.splice(i, 1)
            vm.categories.unshift(item)
          }
        })
        return vm.categories
      }
    },
    ...mapGetters({
      cart: 'getCart',
      isWholesale: 'getWholesaleStatus',
      wholesale: 'getWholesale',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme',
      currencySign: 'currencySign'
    }),
    filterCart() {
      if (this.pageProfile && this.pageProfile.type == 'kanom') {
        return this.cart.filter((el) => {
          return (
            this.filterCategory.findIndex((cat) => {
              return cat.id == el.categoryid
            }) != -1
          )
        })
      } else {
        return this.cart
      }
    },
    totalItem() {
      return this.filterCart.length > 0
        ? this.filterCart
            .map((el) => {
              return parseInt(el.quantity)
            })
            .reduce((prev, cur) => {
              return prev + cur
            })
        : 0
    },
    isKhaiwhan() {
      return (
        this.pageProfile &&
        this.$store.state.khaiwhan.includes(this.pageProfile.pageid)
      )
    },
    pageCount: function () {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    },
    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined
    },
    filterProducts: function () {
      let vm = this
      var filteredProducted = vm.onFilterProducts()
      let a = []
      filteredProducted.filter((product) => {
        return vm.categories.map((category) => {
          if (product.categoryid === category.id && !category.is_hidden) {
            if (
              !vm.$store.getters.isPowerBuyPage ||
              (vm.$store.getters.isPowerBuyPage && !product.isOutOfStock)
            ) {
              a.push(product)
            }
          }
        })
      })
      filteredProducted = a
      vm.productCount = filteredProducted.length

      const start = (vm.pageNumber - 1) * vm.size
      const end = start + vm.size

      return filteredProducted.slice(start, end)
    },
    totalPrice: function () {
      let vm = this
      if (vm.voucher) {
        return vm.voucher.lasttotal
      }
      if (vm.filterCart && vm.filterCart.length > 0) {
        let total = 0
        try {
          total = vm.filterCart.reduce((prev, curr) => {
            if (curr.optionDetail) {
              if (parseInt(curr.optionDetail[2]) >= curr.quantity) {
                prev += curr.bundleprice
              }
            }
            if (
              this.pageProfile.type == 'reka' &&
              curr.addon_json.embroideredNameList &&
              curr.addon_json.embroideredNameList.length > 0
            ) {
              //
              let embroideredNameList =
                curr.addon_json.embroideredNameList.filter((el) => {
                  return el || el != ''
                })
              if (embroideredNameList.length > 0)
                prev += embroideredNameList.length * 100
            }
            return prev
          }, 0)
        } catch (error) {
          //
        }

        return total
      } else {
        return 0
      }
    },

    isTotalMinimum() {
      if (
        ['324885161495477', '103195847822433'].includes(
          this.pageProfile.pageid
        ) &&
        this.totalPrice < 500
      ) {
        return true
      } else if (
        ['108209024822196'].includes(this.pageProfile.pageid) &&
        this.totalPrice < 100
      ) {
        return true
      } else {
        return false
      }
    },
    minimumPrice() {
      if (
        ['324885161495477', '103195847822433'].includes(
          this.pageProfile.pageid
        ) &&
        this.totalPrice < 500
      ) {
        return 500
      } else if (
        ['108209024822196'].includes(this.pageProfile.pageid) &&
        this.totalPrice < 100
      ) {
        return 100
      } else {
        return false
      }
    },
    isAdjustQty() {
      return (
        this.filterCart.filter(function (el) {
          if (el.adjust_qty && el.adjust_qty >= el.quantity) {
            return true
          }
        }).length > 0
      )
    },
    isCDS() {
      return (
        this.pageProfile &&
        this.$store.state.cds.includes(this.pageProfile.pageid)
      )
    },
    currentCategory() {
      if (['all', 'sale', 'usedtobuy'].indexOf(this.selectedCategory) != -1)
        return null
      return this.categories.find((el) => {
        return el.id == this.selectedCategory
      })
    },
    isThailandPostMart() {
      return ['396306053873110', '115414076948160'].includes(
        this.pageProfile.pageid
      )
    },
    isSeagull() {
      return this.pageProfile && ['seagull'].includes(this.pageProfile.theme)
    }
  },
  mounted: function () {
    const vm = this
    vm.mountedMethods()
    if (vm.$route.query.modalOpen) {
      vm.openModal()
    }
  },
  components: {
    Product,
    ModalCheckout,
    SyncLoader,
    Loading,
    Modal,
    MerchantDetail,
    TermAndCondition,
    VoucherCode,
    ModalProduct,
    ModalProduct2,
    ModalForexProduct,
    ModalRunkanProduct,
    GmapNearShop,
    ModalFoodguruTerm,
    Pagination,
    BundleSelect,
    ManageCart,
    Transfer,
    ModalSeagullProduct,
    SeagullTermAndCondition
  },
  methods: {
    async mountedMethods() {
      if (config.env == 'shopcommu') {
        await this.loadCheckBranch(this.pagename)
      }
      try {
        localStorage.removeItem('cartarray')
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
      let vm = this

      vm.loadingCart = true
      vm.userAgent = navigator.userAgent

      await vm.$store.dispatch('loadPageProfile', {
        pagename: vm.pagename,
        userid: vm.$route.query.userid
      })

      if (vm.pageProfile && vm.pageProfile.type === 'tremendous') {
        vm.handleCheckTremendousMember()
      }

      if (vm.pageProfile && vm.pageProfile.type == 'kanom') {
        vm.showShop = true
      }

      if (vm.pageProfile && vm.pageProfile.type == 'foodguru') {
        vm.isFoodguru = true
        vm.checkPdpaFoodguru()

        let orderagain = vm.$route.query.orderagain
        let orderid = vm.$route.query.orderid
        if (orderagain && orderid) {
          vm.onOrderAgainFoodguru()
        }
      }

      if (vm.pageProfile.shop_fb_pixel) {
        window.fbq('init', vm.pageProfile.shop_fb_pixel)
        window.fbq('track', 'PageView')
      }

      vm.hasVoucher = vm.pageProfile.ispromocode

      document.title = vm.pageProfile.pagename
      vm.pageid = vm.pageProfile.pageid

      vm.$store.dispatch('updateShopColor', vm.pageProfile.shopcolor)

      if (vm.$route.query.userid) {
        vm.userid = vm.$route.query.userid
        vm.$store.dispatch(
          'setLang',
          vm.pageProfile.usershoplang || vm.pageProfile.shoplang
        )
      }

      vm.productLoading = true
      if (vm.pageProfile.wholesale_status === true) {
        vm.$store.dispatch('getWholeSale', vm.pageProfile.pageid)
      }

      // For Thailand post mart
      if (
        config.thailandpostmart.pageid.pagename.includes(vm.pageProfile.pageid)
      ) {
        let query = vm.$route.query
        vm.$router.push({
          name: 'thailandpostmart',
          query: { ...query }
        })
      }

      await vm.getCategories()
      if (vm.$route.query.category) {
        if (vm.$route.query.category === 'all') {
          vm.selectedCategory = 'all'
        } else if (vm.$route.query.category === 'sales') {
          vm.selectedCategory = 'sales'
        } else {
          vm.selectedCategory = 'all'
          if (vm.categories) {
            var found = vm.categories.find(function (cat) {
              return cat.id == vm.$route.query.category
            })
            if (found) {
              vm.selectedCategory = vm.$route.query.category
            }
          }
        }
      } else {
        if (
          ['nvbb', 'alice'].includes(vm.pageProfile.type) &&
          vm.categories &&
          vm.categories.length > 0
        ) {
          vm.selectedCategory = vm.categories[0].id.toString()
        }

        if (
          ['foodguru'].includes(vm.pageProfile.type) &&
          vm.$route.query.usedtobuy
        ) {
          vm.selectedCategory = 'usedtobuy'
        }
      }

      if (
        !vm.isThailandPostMart &&
        ((vm.$route.query.view && vm.$route.query.view == 'cart') ||
          (vm.$route.query.tab && vm.$route.query.tab == 'cart'))
      ) {
        await vm.$nextTick()
        vm.openModal()
      }

      const uri = window.location.toString()
      if (location.hash == '#modal-open') {
        if (uri.indexOf('#') > 0) {
          window.location.href.replace('#', '')
          history.replaceState(null, null, window.location.href)
        }
      } else if (location.hash == '#modal-checkout') {
        if (uri.indexOf('#') > 0) {
          window.location.href.replace('#', '')
          history.replaceState(null, null, window.location.href)
        }
        vm.openModal()
      }

      await vm.getProducts()
      if (vm.$route.query.userid && !vm.isThailandPostMart) {
        await vm.getUserCart()
      }

      if (vm.$route.query.category_name) {
        const category_name = vm.$route.query.category_name
        vm.selectedCategory = 'all'
        if (vm.categories) {
          const found = vm.categories.find(function (cat) {
            return (
              cat.name && cat.name.toLowerCase() == category_name.toLowerCase()
            )
          })

          if (found) {
            vm.selectedCategory = found.id.toString()
          }
        }
      }

      if (vm.$route.query.product_name) {
        const product_name = vm.$route.query.product_name
        const productlist = vm.productlist

        productlist.sort(function (a, b) {
          if (a.isOutOfStock && !b.isOutOfStock) {
            return 1
          } else if (!a.isOutOfStock && b.isOutOfStock) {
            return -1
          } else {
            return 0
          }
        })

        const productIndex = productlist.findIndex((product) => {
          return (
            product.name &&
            product.name.toLowerCase() === product_name.toLowerCase()
          )
        })

        if (productIndex > -1) {
          await vm.$nextTick()

          vm.pageNumber = 1
          vm.onSelectProduct(productlist[productIndex])
        }
      }

      if (vm.$route.query.pid) {
        const productid = vm.$route.query.pid
        if (!vm.isThailandPostMart) {
          vm.$route.query.pid = ''
        }
        const products = vm.onFilterProducts()

        const productIndex = products.findIndex((product) => {
          return product.id.toString() === productid.toString()
        })

        if (productIndex > -1) {
          await vm.$nextTick()

          vm.pageNumber = Math.ceil((productIndex + 1) / vm.size)
          vm.onSelectProduct(products[productIndex])
        }
      }
      if (vm.$route.query.influ) {
        const influ = vm.$route.query.influ
        vm.$store.commit('SET_INFLUENCER_ID', influ)
      } else {
        vm.$store.commit('CLEAR_INFLUENCER_ID')
      }

      if (vm.$route.query.sessiontoken) {
        vm.sessiontoken = vm.$route.query.sessiontoken
      }

      window.onscroll = function () {
        vm.scrollY = Math.round(window.pageYOffset)
      }

      if (['nestle'].includes(vm.pageProfile.type)) {
        try {
          const response = await bundleApi.getAllBundles({
            data: {
              pageid: vm.pageProfile.pageid,
              limit: 9999,
              offset: 0
            }
          })
          let product_bundle = []
          if (response.data.product_bundle) {
            product_bundle = response.data.product_bundle.map((bundle) => {
              return {
                ...bundle,
                products: bundle.products.map((product) => {
                  const photourl = product.photourl
                    ? product.photourl.split(';;')
                    : []
                  return { ...product, photourl }
                }, [])
              }
            })
          }
          vm.$store.commit('bundles/SET_BUNDLES', product_bundle)
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      }

      if (['kanom'].includes(vm.pageProfile.type)) await vm.getbranchlocation()
      vm.loadingmap = false

      await vm.wait(1000)
      if (this.$route.query.group_id) {
        vm.getMemberGroup()
      }
      vm.loadingCart = false
    },
    async loadCheckBranch(pageid) {
      const resposne = await axios.get(
        `${config.getConfig('serverUrl')}shop-service-branchs/check-branch`,
        {
          params: { pageId: pageid },
          headers: {
            AUTHORIZATION:
              'Bearer endpei5haTpzaG9wLXNlcnZpY2VAY2hlY2stYnJhbmNocw=='
          }
        }
      )
      this.$store.commit(
        'SET_SHOP_MAIN_PRODUCT',
        resposne.data.shop_main_pageid || null
      )
    },
    onUpdateStock: function () {
      var vm = this
      if (vm.voucher) {
        vm.voucher.onUpdate()
      }
      this.timestamp = moment().format('x')
    },
    async getMemberGroup() {
      var response = await axios.get(
        config.getConfig('serverUrl') +
          `livechat/${this.pageid}/line/${this.$route.query.group_id}/members/${this.$route.query.userid}?sessiontoken=${this.$route.query.sessiontoken}`
      )
      if (response.data.success) {
        this.memberGroup = response.data.result
      }
    },
    onChangeAddon(rand_id, payload) {
      this.$store.commit('EDIT_ALL_ADDON_JSON', {
        index: rand_id,
        addon_json: payload
      })
    },
    async openCheckout() {
      this.closeProduct()
      await this.$nextTick()
      this.timestamp = moment().format('x')
      this.showModal = true
    },
    calshippingpricekanom(distance_km, totalprice) {
      //   var ceiling_distance_km = Math.ceil(distance_km);
      try {
        var ceiling_distance_km = 0
        var decimal = parseFloat((distance_km % 1).toFixed(1))
        distance_km = Math.floor(distance_km)
        if (decimal > 0.4) distance_km += 1
        ceiling_distance_km += distance_km
      } catch (error) {
        return false
      }

      var price = 0
      switch (ceiling_distance_km) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          price = 40
          break
        case 6:
          price = 45
          break
        case 7:
          price = 55
          break
        case 8:
          price = 65
          break
        case 9:
          price = 75
          break
        case 10:
          price = 85
          break
        case 11:
          price = 95
          break
        case 12:
          price = 105
          break
        case 13:
          price = 115
          break
        case 14:
          price = 125
          break
        case 15:
          price = 135
          break
        case 16:
          price = 145
          break
        case 17:
          price = 155
          break
        default:
          return false
      }

      if (this.hasSnackbox && totalprice >= 5000) {
        return 0
      } else if (this.hasSnackbox && totalprice < 5000) {
        return 300
      } else {
        return price
      }
    },
    getbranchlocation() {
      var vm = this
      return new Promise((resolve) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'branchlocation?pageid=' +
              this.pageid
          )
          .then((response) => {
            if (response.data.responsecode == 200) {
              vm.branchlocation = response.data.branchlocation
              let externalScript = document.createElement('script')
              externalScript.setAttribute(
                'src',
                `https://maps.googleapis.com/maps/api/js?key=${response.data.googlekey}&language=th&libraries=places`
              )
              externalScript.async = true
              externalScript.defer = true
              externalScript.onload = () => {
                vm.showmap = true
                resolve()
              }
              document.head.appendChild(externalScript)
            }
          })
      })
    },
    gmapLocation() {
      var vm = this
      var locations = []
      var nearestlocation
      var stringlatlng =
        this.gmapvalue ||
        this.gmapvalue.lat.toString() + ',' + this.gmapvalue.lng.toString()
      // eslint-disable-next-line no-undef
      var service = new google.maps.DistanceMatrixService()
      var origins = vm.branchlocation.map((el) => el.lat_long)

      service.getDistanceMatrix(
        {
          origins,
          destinations: [stringlatlng],
          travelMode: 'DRIVING',
          region: 'TH',

          drivingOptions: {
            departureTime: new Date(),
            trafficModel: 'optimistic'
          }
        },
        callback
      )
      function callback(response, status) {
        if (status == 'OK') {
          var bodyjson = response
          for (var i = 0; i < bodyjson.rows.length; i++) {
            var row = bodyjson.rows[i].elements[0].distance

            try {
              locations.push({
                name: vm.branchlocation[i].name,
                distance: parseFloat((row.value / 1000).toFixed(2)),
                pictureurl: vm.branchlocation[i].pictureurl
              })
            } catch (error) {
              //console.error(error);
            }
          }

          locations.sort((a, b) => {
            var x = a.distance
            var y = b.distance
            return x < y ? -1 : x > y ? 1 : 0
          })

          nearestlocation = locations[0]
          vm.shippingAddress = response.destinationAddresses[0]
          vm.placesinfo = response.destinationAddresses[0]
          vm.ggmapdistance = nearestlocation
          var shippingprice = vm.calshippingpricekanom(
            nearestlocation.distance,
            vm.totalincludediscount
          )
          vm.ableToShipping = shippingprice !== false
          vm.kanomshippingprice = vm.ableToShipping ? shippingprice : 0

          if (vm.branchlocation && vm.branchlocation.length > 1) {
            vm.banktransferinfo_photo = nearestlocation.pictureurl
          } else {
            vm.banktransferinfo_photo = vm.mainBankTransferInfoPhoto
          }

          var location_name = vm.shopOptions.find((el) => {
            return el.includes(nearestlocation.name)
          })
          if (location_name) vm.shop = location_name
        } else {
          // 400
        }
      }
    },

    selectShop() {
      this.$store.dispatch('updateAllCart', this.filterCart)

      this.showShop = false
    },
    wait(time) {
      return new Promise((resolve) =>
        setTimeout(() => {
          resolve()
        }, time)
      )
    },
    async onSelectProduct(product) {
      this.currentProduct = product
      await this.$nextTick()

      this.showProductModal = true
      let vm = this
      await this.$nextTick()

      this.$vuetify.goTo(0, {
        duration: 0,
        offset: 0,
        easing: 'linear'
      })
      window.history.pushState({ modal: 'open' }, '', '#modal-open')
      window.onpopstate = async function (event) {
        if (event.state && event.state.modal == 'open') {
          //
        } else {
          vm.showProductModal = false
          vm.showModal = false
          if (vm.$route.query && vm.$route.query.shoptoken) {
            vm.viewTransferPage = false
            vm.productLoading = true
            await vm.mountedMethods()
          }
        }
      }
    },
    async closeProduct() {
      this.showProductModal = false
      await this.$nextTick()
      this.$vuetify.goTo(10, {
        duration: 100,
        offset: 0,
        easing: 'linear'
      })
      await this.$nextTick()
      this.$vuetify.goTo(0, {
        duration: 100,
        offset: 0,
        easing: 'linear'
      })
    },

    onFilterProducts() {
      const vm = this
      let filteredProducted = []
      var productlist = []
      if (vm.pageProfile && vm.pageProfile.type == 'kanom') {
        productlist = vm.productlist.filter((el) => {
          return (
            vm.filterCategory.findIndex((cat) => cat.id == el.categoryid) != -1
          )
        })
      } else {
        productlist = vm.productlist
      }

      if (productlist && vm.selectedCategory == 'sales') {
        productlist.forEach(function (val) {
          if (parseFloat(val.price) > parseFloat(val.discountprice)) {
            filteredProducted.push(val)
          } else {
            var isDiscount = false
            if (val.productstock) {
              val.productstock.map(function (stock) {
                if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                  isDiscount = true
                }
              })
            }

            if (isDiscount) {
              filteredProducted.push(val)
            }
          }
        })
      } else if (productlist && vm.selectedCategory != 'all') {
        if (
          vm.pageProfile.type == 'foodguru' &&
          vm.selectedCategory == 'usedtobuy'
        ) {
          filteredProducted = productlist.filter(function (el) {
            return el.used_to_buy_product == true
          })
        } else {
          filteredProducted = productlist.filter(function (el) {
            return vm.selectedCategory == el.categoryid
          })
        }
      } else {
        filteredProducted = productlist
      }

      if (vm.search != '' && filteredProducted) {
        filteredProducted = filteredProducted.filter((product) => {
          return (
            (product.name &&
              product.name.toLowerCase().includes(vm.search.toLowerCase())) ||
            (product.code &&
              product.code.toLowerCase().includes(vm.search.toLowerCase()))
          )
        })
      }

      filteredProducted.sort(function (a, b) {
        if (a.isOutOfStock && !b.isOutOfStock) {
          return 1
        } else if (!a.isOutOfStock && b.isOutOfStock) {
          return -1
        } else {
          return 0
        }
      })

      return filteredProducted
    },
    matchCategoryWidth: function () {
      let vm = this
      let totalWidth = this.getStyle('#filter #container', 'contentWidth')
      let searchWidth = this.getStyle('#search-btn', 'width')
      if (!totalWidth || !searchWidth) {
        return false
      }
      totalWidth = totalWidth - searchWidth - 25
      vm.categoriesWidth = totalWidth + 'px'
    },
    openModal: function () {
      this.showModal = true
      this.timestamp = moment().format('x')
      let vm = this
      window.history.pushState({ modal: 'open' }, '', '#modal-open')
      window.onpopstate = async function (event) {
        if (event.state && event.state.modal == 'open') {
          //
        } else {
          vm.showModal = false
          vm.showProductModal = false
          if (vm.$route.query && vm.$route.query.shoptoken) {
            vm.viewTransferPage = false
            vm.productLoading = true
            await vm.mountedMethods()
          }
        }
      }
    },
    close: function () {
      this.showModal = false
    },
    closeTerm: function () {
      var vm = this
      if (window.history.length == 0) {
        vm.showTerm = false
      } else {
        window.history.back()
      }
    },
    getUserCart() {
      let vm = this
      let params = {
        pageid: vm.pageid,
        userid: vm.userid
      }
      if (
        vm.pageProfile &&
        vm.pageProfile.useketshop == true &&
        vm.pageProfile.ketshop_api_key &&
        vm.pageProfile.ketshop_api_secret
      ) {
        params.ref_system_name = 'ketshop'
      }

      return new Promise(async (resolve) => {
        vm.$store.dispatch('deleteAllItemsInCart')
        try {
          let data = {}
          if (vm.$route.query && vm.$route.query.shoptoken) {
            data.shop_token = vm.$route.query.shoptoken
          }
          var response

          let url =
            vm.pageProfile.type == 'thaiairways'
              ? `${config.thaiairways.serverUrl}v2/usercart`
              : `${config.getConfig('serverUrl')}v2/usercart`
          response = await axios.post(url, data, {
            params
          })

          // JSON responses are automatically parsed.
          response = response.data
          if (response.responsecode == 200) {
            let data = response.result
            vm.$store.commit('SET_CART_ID', data.cart_ids || [])
            if (data.cartarray) {
              var product_id_list = []
              var products = []
              products = data.cartarray.map(function (val) {
                product_id_list.push(val.productid)
                var option = null
                var productIndex = vm.allproducts.findIndex((el) => {
                  return el.id == val.productid
                })
                if (productIndex != -1) {
                  var stock = vm.allproducts[productIndex].productstock

                  option = stock.find(function (el) {
                    if (['khaiwhan', 'gaigao'].includes(vm.pageProfile.type)) {
                      if (val.option != 'Normal') {
                        return el[1] == val.option.split(' - ')[0]
                      } else {
                        return el[1] == 'Normal'
                      }
                    } else {
                      return el[1] == val.option
                    }
                  })
                }
                if (
                  vm.pageProfile &&
                  vm.pageProfile.useketshop == true &&
                  vm.pageProfile.ketshop_api_key &&
                  vm.pageProfile.ketshop_api_secret
                ) {
                  val = Object.assign(vm.allproducts[productIndex], val)
                }
                return {
                  ...val,
                  id: val.productid,
                  price: parseFloat(val.price),
                  discountprice: parseFloat(val.discountprice),
                  optionDetail: option
                }
              })

              if (products.length > 0) {
                vm.$store.commit('SET_ALL_CART', products)
                let url =
                  vm.pageProfile.type == 'thaiairways'
                    ? `${
                        config.thaiairways.serverUrl
                      }productbundle?productid=${product_id_list.join(',')}`
                    : `${config.getConfig(
                        'serverUrl'
                      )}productbundle?productid=${product_id_list.join(',')}`
                var bundle_response = await axios.get(url)
                bundle_response = bundle_response.data

                if (
                  bundle_response.responsecode == 200 &&
                  bundle_response.productbundlelist.length > 0
                ) {
                  vm.$store.commit(
                    'UPDATE_BUNDLE_CART',
                    bundle_response.productbundlelist
                  )
                }
              }
            }

            resolve()
          } else if (
            response.responsecode == 400 &&
            response.reason == 'CART_NOT_FOUND'
          ) {
            resolve()
          } else if (
            response.responsecode == 400 &&
            response.reason == 'CAN_BUY_ONLY_1_ORDER_PER_DAY'
          ) {
            vm.onlyOneQuantity = true
            resolve()
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      })
    },

    getProducts: async function () {
      let vm = this
      return new Promise((resolve, reject) => {
        this.productLoading = true
        let offset = 0
        let allProduct = []
        this.loadProducts(offset).then(
          async (products) => {
            if (
              vm.pageProfile &&
              vm.pageProfile.useketshop == true &&
              vm.pageProfile.ketshop_api_key &&
              vm.pageProfile.ketshop_api_secret
            ) {
              offset = offset + 100
              allProduct = products.productlist
              for (offset; offset < products.total_records; offset += 100) {
                var prod = await this.loadProducts(offset)
                allProduct = allProduct.concat(prod.productlist)
              }
            } else {
              allProduct = products.productlist
            }
            vm.products = {}
            const avaliableProducts = allProduct.filter((el) => {
              // console.log(el.status);
              return el.status == true
            })

            var result = vm.formatProducts(avaliableProducts, vm.categories)
            var allresult = vm.formatProducts(allProduct)
            vm.products = allresult.product_by_index

            vm.productlist = result.products
            vm.allproducts = allresult.products

            vm.hasSaleCategory = false

            vm.productlist.forEach((val) => {
              if (parseFloat(val.price) > parseFloat(val.discountprice)) {
                vm.hasSaleCategory = true
              } else {
                var isDiscount = false
                if (val.productstock) {
                  isDiscount = val.productstock.find(function (stock) {
                    return parseFloat(stock[3]) > parseFloat(stock[4])
                  })
                }

                if (isDiscount) {
                  vm.hasSaleCategory = true
                }
              }
            })

            this.productLoading = false
            resolve()
          },
          (error) => {
            // eslint-disable-next-line no-console
            console.error(error)
            this.productLoading = false
            reject(error)
          }
        )
      })
    },
    loadProducts(offset) {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageid,
          userid: vm.userid
        }
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.pageProfile.ketshop_api_key
          data['ketshop_api_secret'] = vm.pageProfile.ketshop_api_secret
          data['limit'] = 100
          data['offset'] = offset
        }

        if (vm.$store.state.shop_main_pageid && config.env == 'shopcommu') {
          Object.assign(data, {
            shop_main_pageid: vm.$store.state.shop_main_pageid
          })
        }

        let url =
          vm.pageProfile.type == 'thaiairways'
            ? `${config.thaiairways.serverUrl}products`
            : `${config.getConfig('serverUrl')}products`
        axios
          .get(url, {
            params: data
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              if (response.productlist) {
                resolve(response)
              }
            } else {
              // console.log(response);
              reject()
            }
          })
          .catch(() => {
            vm.productLoading = false
            reject()
          })
      })
    },
    getCategories() {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageid
        }

        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.pageProfile.ketshop_api_key
          data['ketshop_api_secret'] = vm.pageProfile.ketshop_api_secret
        }

        if (vm.$store.state.shop_main_pageid && config.env == 'shopcommu') {
          Object.assign(data, {
            shop_main_pageid: vm.$store.state.shop_main_pageid
          })
        }

        let url =
          vm.pageProfile.type == 'thaiairways'
            ? `${config.thaiairways.serverUrl}categories`
            : `${config.getConfig('serverUrl')}categories`
        axios
          .get(url, {
            params: data
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.categories = []
              try {
                vm.categories = response.categorylist.map((category) => {
                  var c = category
                  c.productCount = 0
                  return c
                })
              } catch (error) {
                //
              }

              resolve()
            } else {
              reject()
            }
          })
      })
    },

    checkout: async function (isClose, isCentral) {
      const vm = this
      let isSkip = !['cds'].includes(vm.pageProfile.type)
      if (isCentral) {
        isSkip = false
      }
      if (
        vm.pageProfile &&
        vm.pageProfile.useketshop == true &&
        vm.pageProfile.ketshop_api_key &&
        vm.pageProfile.ketshop_api_secret
      ) {
        isSkip = false
      }

      isClose = isClose ? isClose : false
      if (!vm.filterCart) {
        return false
      }
      vm.loadingCheckout = true

      let { data, params } = await vm.setupParamAndData()

      data.cartarray = vm.filterCart.map((val) => {
        let quantity = 1
        if (vm.pageProfile.theme == 'runkan') {
          quantity = 1
        } else {
          quantity = val.quantity
        }
        let addon_json = val.addon_json || {}
        if (
          vm.pageProfile.type == 'reka' &&
          addon_json.embroideredNameList &&
          addon_json.embroideredNameList.length > 0
        ) {
          addon_json.text = ''
          if (addon_json.embroideredNameList.length > quantity) {
            addon_json.embroideredNameList =
              addon_json.embroideredNameList.splice(0, quantity)
          }
          addon_json.text = addon_json.embroideredNameList.reduce(
            (prev, curr, index) => {
              prev += `ปักชื่อ (${index + 1}) +฿100:\n ${curr}\n`
              return prev
            },
            ''
          )

          addon_json.additional_price =
            addon_json.embroideredNameList.length * 100
        }

        var option = {
          pid: val.id,
          qty: quantity,
          option: val.option,
          cart_remark: val.cart_remark,
          addon_json: JSON.stringify(addon_json)
        }

        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          option['ketshop_option'] = val.optionid
        }

        return option
      })

      try {
        let response = await vm.proceedCart(data, params)
        response = response.data
        if (response.responsecode == 200) {
          if (isClose) {
            // eslint-disable-next-line
            if (vm.$liff.isInClient() && vm.pageProfile.type !== 'runkan') {
              // eslint-disable-next-line
              try {
                if (!vm.$store.getters.isPowerBuyPage) {
                  await vm.$liff.sendMessages([
                    {
                      type: 'text',
                      text: vm.$t('Cart Summary')
                    }
                  ])
                }
              } catch (error) {
                //
              }

              // eslint-disable-next-line

              try {
                if (isSkip) {
                  var query_string = []
                  var query_string_from_url = vm.$route.query
                  delete query_string_from_url.view
                  query_string_from_url.lang = vm.currentLang

                  for (const query_name in query_string_from_url) {
                    query_string.push(
                      `${query_name}=${query_string_from_url[query_name]}`
                    )
                  }

                  if (vm.$route.query.app == 'line') {
                    vm.$route.query.id = vm.pageProfile.pageid
                    vm.$route.query.lang = vm.currentLang
                    vm.$store.state.view = 'transfer'
                  } else {
                    vm.$router.push({
                      name: 'transfer',
                      params: { id: vm.pageProfile.pageid },
                      query: { ...vm.$route.query, lang: vm.currentLang }
                    })
                  }
                } else {
                  if (
                    vm.pageProfile &&
                    vm.pageProfile.useketshop == true &&
                    vm.pageProfile.ketshop_api_key &&
                    vm.pageProfile.ketshop_api_secret
                  ) {
                    vm.$liff.openWindow({
                      url: response.result.link
                    })
                  } else {
                    vm.$liff.closeWindow()
                  }
                }
              } catch (error) {
                //
              }
            } else {
              if (vm.$liff.isInClient()) {
                try {
                  if (!vm.$store.getters.isPowerBuyPage) {
                    await vm.$liff.sendMessages([
                      {
                        type: 'text',
                        text: vm.$t('Cart Summary')
                      }
                    ])
                  }
                } catch (error) {
                  //
                }
              }

              // eslint-disable-next-line

              if (isSkip) {
                if (vm.$route.query.app == 'line') {
                  vm.$route.query.id = vm.pageProfile.pageid
                  vm.$route.query.lang = vm.currentLang
                  vm.$store.state.view = 'transfer'
                } else {
                  if (vm.$route.query && vm.$route.query.shoptoken) {
                    vm.viewTransferPage = true
                  } else {
                    vm.$router.push({
                      name: 'transfer',
                      params: { id: vm.pageProfile.pageid },
                      query: { ...vm.$route.query, lang: vm.currentLang }
                    })
                  }
                }
              } else {
                // eslint-disable-next-line no-undef
                if (
                  vm.pageProfile &&
                  vm.pageProfile.useketshop == true &&
                  vm.pageProfile.ketshop_api_key &&
                  vm.pageProfile.ketshop_api_secret
                ) {
                  window.open(response.result.link, '_parent')
                } else {
                  // eslint-disable-next-line no-undef
                  if (MessengerExtensions) {
                    if (isCentral) {
                      // eslint-disable-next-line no-undef
                      MessengerExtensions.requestCloseBrowser(
                        function success() {},
                        function error() {
                          window.close()
                        }
                      )
                      await vm.$swal({
                        title: vm.$t('Successfully'),
                        text: vm.$t('This cart has been updated.'),
                        type: 'success',
                        confirmButtonText: vm.$t('Confirm'),
                        reverseButtons: true
                      })
                    } else {
                      // eslint-disable-next-line no-undef
                      MessengerExtensions.requestCloseBrowser(
                        function success() {},
                        function error() {
                          window.close()
                        }
                      )
                    }
                  } else {
                    window.close()
                  }
                }
              }
            }
          }
        } else if (response.responsecode == 201) {
          if (vm.pageProfile.theme == 'runkan') {
            vm.$swal({
              html:
                'กรุณากรอกรายละเอียดก่อนการชำระเงิน<br/>' +
                'ให้น้องรันกันหน่อยนะครับ',
              confirmButtonColor: '#000',
              confirmButtonText: vm.$t('OK')
            }).then((result) => {
              if (result.value) {
                let pageid = vm.pageProfile.pageid
                let liffid = ''

                if (pageid == '101211282011006') {
                  liffid = '1655728655-Jox9VpOD' // runkantest.zwiz.ai
                  // liffid = "1655728655-Q9gmOwRk"; // Test on localhost
                } else if (pageid == '141495096441743') {
                  liffid = '1655728655-KyAxlvWJ' // runkan.zwiz.ai
                }

                vm.$liff.openWindow({
                  url: `https://liff.line.me/${liffid}?view=Register&pageid=${pageid}&apptype=line`
                })
              }
            })
          } else {
            vm.redirecturl = response.redirecturl
            vm.showRedirectToSocial = true
          }
        } else {
          await vm.$swal({
            title: vm.$t('Error'),
            text: vm.$t('Something went wrong. Please try it again.'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          // eslint-disable-next-line
          if (vm.$liff.isInClient()) {
            // eslint-disable-next-line no-undef
            vm.$liff.closeWindow()
          } else {
            // eslint-disable-next-line no-undef
            if (MessengerExtensions) {
              // eslint-disable-next-line no-undef
              MessengerExtensions.requestCloseBrowser(
                function success() {},
                function error() {
                  window.close()
                }
              )
            } else {
              window.close()
            }
          }
        }

        if (!isCentral && !vm.pageProfile.useketshop) {
          await vm.$store.dispatch('deleteAllItemsInCart')
        }

        vm.loadingCheckout = false
      } catch (error) {
        let errorMessage = null
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message
        }
        vm.loadingCheckout = false
        vm.close()
        await vm.$swal({
          title: vm.$t('Error'),
          text: errorMessage
            ? errorMessage
            : vm.$t('Something went wrong. Please try it again.'),
          type: 'error',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
      }
    },
    async setupParamAndData() {
      let data = {
          cartarray: []
        },
        params = {}
      params = {
        pageid: this.pageid
      }
      if (this.userid != null && this.userid != '') {
        params.userid = this.userid
      }

      if (this.sessiontoken != null && this.sessiontoken != '') {
        params.sessiontoken = this.sessiontoken
      }

      if (this.voucher) {
        data.promocode = this.voucher.promocode
      }
      if (this.$route.query.group_id) {
        data.group_id = this.$route.query.group_id
      }
      if (this.$route.query.from) {
        data.from = this.$route.query.from
      } else {
        try {
          var device = this.$liff.getOS()
          var version = this.$liff.getVersion()
          await this.$liff.ready

          if (
            this.userid.indexOf('__') != -1 &&
            device &&
            version &&
            !this.$liff.isInClient()
          ) {
            data.from = 'livechat'
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log(error)
        }
      }
      if (this.$route.query.admintoken) {
        data.admin_jwt = this.$route.query.admintoken
        if (this.$route.query.adminpromocode) {
          data.promocode = this.$route.query.adminpromocode
        }
      }
      return { data, params }
    },
    async createUserWalkIn() {
      try {
        const userResponse = await seagullApi.postWalkInUser(
          this.pageProfile.pageid
        )
        return userResponse.data
      } catch (error) {
        this.$swal.fire({
          text: 'สร้างผู้ใช้ไม่สำเร็จ',
          type: 'error'
        })
      }
    },
    async proceedCart(data, params) {
      let vm = this
      if (vm.pageProfile.type == 'seagull') {
        const userData = await vm.createUserWalkIn()
        if (
          vm.$route.query &&
          vm.$route.query.create_user &&
          vm.$route.query.create_user == 'true'
        ) {
          params = { ...params, ...userData }
          vm.$route.query.userid = userData.userid
          vm.$route.query.sessiontoken = userData.sessiontoken
        }
      }
      if (vm.$route.query && vm.$route.query.shoptoken) {
        data.shop_token = vm.$route.query.shoptoken
      }
      let url =
        vm.pageProfile.type == 'thaiairways'
          ? `${config.thaiairways.serverUrl}addproductstocart_array`
          : `${config.getConfig('serverUrl')}addproductstocart_array`
      var response = await axios.post(url, data, {
        params: params
      })
      return response
    },
    async addAndUpdateCart() {
      const vm = this
      if (vm.pageProfile.type != 'nestle') {
        return false
      }
      let { data, params } = await vm.setupParamAndData()

      data.cartarray = vm.filterCart.map((val) => {
        let quantity = 1
        if (vm.pageProfile.theme == 'runkan') {
          quantity = 1
        } else {
          quantity = val.quantity
        }
        let addon_json = val.addon_json || {}
        if (
          vm.pageProfile.type == 'reka' &&
          addon_json.embroideredNameList &&
          addon_json.embroideredNameList.length > 0
        ) {
          addon_json.text = ''
          if (addon_json.embroideredNameList.length > quantity) {
            addon_json.embroideredNameList =
              addon_json.embroideredNameList.splice(0, quantity)
          }
          addon_json.text = addon_json.embroideredNameList.reduce(
            (prev, curr, index) => {
              prev += `ปักชื่อ (${index + 1}) +฿100:\n ${curr}\n`
              return prev
            },
            ''
          )

          addon_json.additional_price =
            addon_json.embroideredNameList.length * 100
        }

        var option = {
          pid: val.id,
          qty: quantity,
          option: val.option,
          cart_remark: val.cart_remark,
          addon_json: JSON.stringify(addon_json)
        }

        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          option['ketshop_option'] = val.optionid
        }

        return option
      })
      data.isSendCheckout = false
      try {
        await vm.proceedCart(data, params)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    addToCart: async function ({ item, loading }) {
      if (
        this.pageProfile.type == 'chillpainai' &&
        this.$store.state.influencerid
      ) {
        item.cart_remark = this.$store.state.influencerid
      }
      if (['chillpainai', 'runkan'].includes(this.pageProfile.type)) {
        this.$store.dispatch('deleteAllItemsInCart')
      }
      let tmp = {
        ...item,
        optionid: item.option[0],
        option: item.option[1],
        max: item.option[2],
        productid: item.id,
        optionDetail: item.option
      }
      let vm = this

      await this.$store.dispatch('addToCart', { product: tmp })
      if (vm.voucher) {
        vm.voucher.onUpdate()
      }
      if (
        vm.isCDS ||
        ['rabbit', 'chillpainai', 'runkan'].includes(vm.pageProfile.type)
      ) {
        await vm.checkout(true)
      } else if (['forex'].includes(vm.pageProfile.type)) {
        await vm.checkout(false)
      } else {
        //
      }
      await vm.addAndUpdateCart()
      if (loading) {
        loading()
      }
    },
    async deleteItemInCart(rand_id) {
      try {
        // this.showDelete = true;
        let result = await this.$swal({
          title: this.$t('Do you want to remove this') + '?',

          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('Cancel'),
          reverseButtons: true
        })
        if (result.value) {
          await this.$store.dispatch('deleteFromCart', rand_id)
        }
        if (this.voucher) {
          this.voucher.onUpdate()
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    async onDeleteItem() {
      if (this.deleteIndex != null) {
        await this.$store.dispatch('deleteFromCart', this.deleteIndex)
      }
      this.showDelete = false
    },
    openTerm: function () {
      this.showTerm = true
      let vm = this
      window.history.pushState({ modal: 'open' }, '', '#modal-open')
      window.onpopstate = function (event) {
        if (event.state && event.state.modal == 'open') {
          //
        } else {
          vm.showTerm = false
        }
      }
    },
    openSearch: function () {
      let vm = this
      vm.showSearch = !vm.showSearch
      if (vm.showSearch) {
        this.$nextTick(() => this.$refs.search.focus())
      } else {
        vm.search = ''
      }
    },
    onChangeCategory: function () {
      this.pageNumber = 1
    },
    filterProductsList(list) {
      var value = this.productlist.filter(function (e) {
        return this.indexOf(e.id) >= 0
      }, list)
      return value
    },
    showShippingFeeFoodguru() {
      this.ModalShippingFeeFoodguru = true
    },
    closeShippingFeeFoodguru() {
      this.ModalShippingFeeFoodguru = false
    },
    async checkPdpaFoodguru() {
      var vm = this
      var data = {
        pageid: vm.pageProfile.pageid,
        userid: vm.$route.query.userid
      }

      await axios
        .get(config.getConfig('serverUrl') + 'foodguru/checkPdpa', {
          headers: {
            AUTHORIZATION: 'Bearer xxx xxx'
          },
          params: data
        })
        .then((response) => {
          if (response.data.responsecode == 200) {
            var url = this.$route.fullPath
            let usedtobuy = this.$route.query.usedtobuy
            if (usedtobuy) {
              this.hasUsedToBuy = true
              // url += "&usedtobuy=" + this.hasUsedToBuy;
            } else {
              this.hasUsedToBuy = false
            }

            this.$router.push({ path: url }).catch(() => {})
          } else if (response.data.responsecode == 204) {
            this.showFoodguruTerm = true
          } else {
            this.$swal.fire({
              text: response.data.reason
            })
          }
        })
    },
    async onOrderAgainFoodguru() {
      var vm = this
      let url = config.getConfig('serverUrl') + 'foodguru/orderAgain'
      var data = {
        pageid: vm.pageProfile.pageid,
        userid: vm.$route.query.userid,
        orderid: vm.$route.query.orderid
      }

      let response = await axios.post(url, data, {
        headers: {
          AUTHORIZATION: 'Bearer xxx xxx'
        }
      })
      response = response.data

      if (response.responsecode == 200) {
        vm.openCheckout()
      } else if (response.responsecode == 204) {
        window.history.back()
      } else {
        this.$swal.fire({
          text: response.data.reason
        })
      }
    },
    closeFoodguruTerm: function () {
      var vm = this
      if (window.history.length == 0) {
        vm.showFoodguruTerm = false
      } else {
        window.history.back()
      }
    },
    async handleCheckTremendousMember() {
      const vm = this
      try {
        const userId = vm.$route.query && vm.$route.query.userid
        const pageId = vm.pageProfile && vm.pageProfile.pageid
        const url = `${config.getConfig(
          'serverUrl'
        )}api/tremendous/liff/${pageId}/member-info/${userId}`

        const response = await axios.get(url, {
          headers: {
            AUTHORIZATION: 'Bearer xxx xxx'
          }
        })

        if (response && response.status === 200) {
          vm.$store.state.tremendousMemberInfo = response.data.data[0]
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    }
  },
  watch: {
    showModal: function (newVal) {
      if (newVal) {
        this.addClass('body', 'modal-open')
      } else {
        this.removeClass('body', 'modal-open')
      }
    },
    search: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    },
    pageNumber: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: 'linear'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.extra {
  padding-bottom: 125px !important;
}
</style>
